const INTRO_TEMPLATES = {
  xml: '<?xml version="1.0" encoding="UTF-8"?>\n',
  html: '<html lang="en" data-line-spacing="1">\n<body>\n'
}

const OUTRO_TEMPLATES = {
  xml: '',
  html: '</body>\n</html>\n'
}

const INTRO_TAG = {
  xml: '<?xml',
  html: '<html'
}

const detectTemplateFormat = (template: string) => {
  const trimmedTemplate = template.trim()
  if (trimmedTemplate.match('</col>')) {
    return 'xml'
  } else {
    // Default to XML if format is not detectable
    return 'html'
  }
}

const introTagAlreadyPresented = (template: string, format: 'xml' | 'html') => template
  .startsWith(format === 'xml' ? INTRO_TAG.xml : INTRO_TAG.html)

const prepareTemplate = (template: string) => {
  const detectedFormat = detectTemplateFormat(template)

  if (introTagAlreadyPresented(template, detectedFormat)) return template

  const intro = detectedFormat === 'xml' ? INTRO_TEMPLATES.xml : INTRO_TEMPLATES.html
  const outro = detectedFormat === 'xml' ? OUTRO_TEMPLATES.xml : OUTRO_TEMPLATES.html
  return `${intro}${template}${outro}`
}

export { prepareTemplate }
